import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"; // Import arrow icon
import TextField from "@mui/material/TextField";
import axiosInstance from "../../components/AxiosInstance";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Alert } from "@mui/material";
import useSharedLink from "../SharedLink";
import { styled } from "@mui/material/styles";
import { buttonStyle } from "../../constants"; // ✅ Import the styles
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  // Button,
} from "@mui/material";

// Square Button for Toggle
const SquareButton = styled(Button)(({ theme }) => ({
  width: "60px",
  height: "60px",
  minWidth: "50px",
  borderRadius: "10px",
  backgroundColor: "#007bff",
  color: "white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&:hover": {
    backgroundColor: "#0056b3",
  },
  transition: "0.3s ease",
}));

const ExpandButton = styled(Button)(({ theme }) => ({
  width: "90vw",
  // maxWidth: "750px",
  height: "55px",
  fontSize: "1.2rem",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: "#1a1a1a",
  color: "white",
  "&:hover": { backgroundColor: "#333" },
  transition: "0.3s ease",
  padding: "10px 20px",
  textTransform: "none",
}));
const PasswordChange = () => {
  const sharedLink = useSharedLink();
  const [input, setInput] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [optOutSMS, setOptOutSMS] = useState(false); // Checkbox state
  const [showOptOutSMS, setShowOptOutSMS] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [error, setError] = useState("");
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [tempOptOut, setTempOptOut] = useState(false); // Temporary state before confirming
  const [showOptInSMS, setShowOptInSMS] = useState(false);
  const [tempOptIn, setTempOptIn] = useState(false);
  const [optInSMS, setOptInSMS] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput({
      ...input,
      [name]: value,
    });
    setError(""); // Clear error when user starts typing
  };

  // 🔹 Fetch SMS Opt-in Status when the page loads
  useEffect(() => {
    fetchSMSOptStatus(); // Fetch opt-in status on component mount
  }, []);

  const fetchSMSOptStatus = async () => {
    const email = localStorage.getItem("username");
    if (!email) {
      console.error("No email found in local storage.");
      return;
    }

    try {
      const response = await axiosInstance.post(
        `${sharedLink}/getsmsoptstatus`,
        { email },
        {
          headers: { "Content-Type": "application/json", Expect: undefined },
        }
      );

      if (response.status === 200) {
        console.log("API Response:", response.data); // Debugging
        const isOptedIn = Boolean(response.data); // ✅ Ensure boolean value
        setOptInSMS(isOptedIn); // ✅ Ensure checkbox updates properly
      } else {
        console.warn("Unexpected response:", response.data);
      }
    } catch (error) {
      console.error("Error fetching SMS opt status:", error);
    }
  };

  // 🔹 Handle Checkbox Click - Open Dialog
  const handleCheckboxChange = (e) => {
    setTempOptIn(e.target.checked);
    setDialogOpen(true);
  };

  // 🔹 Handle Dialog Confirmation
  const handleDialogClose = async (confirm) => {
    if (confirm) {
      await toggleSMSOptIn(tempOptIn);
    }
    setDialogOpen(false);
  };

  const toggleSMSOptIn = async (optIn) => {
    const email = localStorage.getItem("username");
    if (!email) {
      console.error("No email found in local storage.");
      return;
    }

    const endpoint = optIn ? "/smsactivate" : "/smsdeactivate";
    console.log(`Calling API: ${endpoint}`);

    try {
      const response = await axiosInstance.post(
        `${sharedLink}${endpoint}`,
        { email },
        {
          headers: { "Content-Type": "application/json", Expect: undefined },
        }
      );

      if (response.status === 200) {
        console.log(`Successfully ${optIn ? "activated" : "deactivated"} SMS.`);

        setOptInSMS(optIn); // ✅ Update state before fetching new status

        setTimeout(() => fetchSMSOptStatus(), 300); // ✅ Slight delay to avoid race condition
      } else {
        console.error(`Failed to ${optIn ? "activate" : "deactivate"} SMS.`);
      }
    } catch (error) {
      console.error(
        `Error in ${optIn ? "activating" : "deactivating"} SMS:`,
        error
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (input.newPassword !== input.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    // if (!input.newPassword || input.newPassword.length < 8) {
    //   setError("Password must be at least 8 characters long.");
    //   return;
    // }
    // Here you would handle the password change logic
    const fetchStaffDetails = async () => {
      try {
        const userId = localStorage.getItem("username"); // Ensure the key is correct
        if (!userId) {
          setError("No user ID found in local storage.");
          return;
        }
        const payload = {
          username: userId,
          password: input.newPassword,
        };
        console.log(payload);

        axiosInstance
          .post(
            sharedLink + "/updateuser",
            {
              username: userId,
              password: input.newPassword,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Expect: undefined,
              },
            }
          )
          .then((response) => {
            console.log(response);
            if (response.status === 200) {
              setAlert(true);
              setInput({
                currentPassword: "",
                newPassword: "",
                confirmPassword: "",
              });
              setAlertContent("Password Changed successfully");
            } else {
              setError("An error occurred while Chaning Password.");
            }
          })
          .catch((err) => {
            console.error(err);
            setError("An error occurred while Chaning Password.");
          });

        // Clear the input after successful password change
      } catch (err) {
        setError("An error occurred while Chaning Password.");
        console.error(err);
      }
    };

    fetchStaffDetails();
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      Height="120vh"
      marginTop="60px"
      gap={3}
      // sx={{ marginTop: "-110px" }} // Adjusted upward positioning
    >
      {/* Opt-out SMS Section */}
      <Box display="flex" alignItems="center" gap={1}>
        <SquareButton
          onClick={() => setShowOptOutSMS(!showOptOutSMS)}
          sx={{ minWidth: "50px" }}
        >
          <ExpandMoreIcon
            sx={{
              transition: "transform 0.3s ease",
              transform: showOptOutSMS ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </SquareButton>
        <ExpandButton onClick={() => setShowOptOutSMS(!showOptOutSMS)}>
          Manage SMS
        </ExpandButton>
      </Box>

      {/* Smooth Transition for Checkbox */}
      <Collapse in={showOptOutSMS} timeout={300}>
        <FormControlLabel
          control={
            <Checkbox
              checked={!!optInSMS} // ✅ Double negation ensures a boolean value
              onChange={handleCheckboxChange} // Open Dialog Instead
              sx={{
                transform: "scale(1.5)", // 🔹 Make checkbox bigger
                color: "#007bff", // 🔹 Default color
                "&.Mui-checked": { color: "#0056b3" }, // 🔹 Custom checked color
                "&:hover": { backgroundColor: "rgba(0, 123, 255, 0.1)" }, // 🔹 Hover effect
              }}
            />
          }
          label={
            <span
              style={{ fontSize: "1.2rem", fontWeight: "bold", color: "#333" }}
            >
              {optInSMS ? "Opt-out SMS" : "Opt-in SMS"}{" "}
              {/* ✅ Use `optInSMS` for label */}
            </span>
          } // Change label dynamically
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            backgroundColor: "#f8f9fa", // 🔹 Light background
            padding: "10px 15px",
            borderRadius: "8px", // 🔹 Rounded edges
            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)", // 🔹 Subtle shadow
            width: "fit-content",
            transition: "0.3s ease",
            "&:hover": { backgroundColor: "#e9ecef" }, // 🔹 Smooth hover effect
          }}
        />
      </Collapse>

      {/* Reset Password Section */}
      <Box display="flex" alignItems="center" gap={1}>
        <SquareButton
          onClick={() => setShowResetPassword(!showResetPassword)}
          sx={{ minWidth: "50px" }}
        >
          <ExpandMoreIcon
            sx={{
              transition: "transform 0.3s ease",
              transform: showResetPassword ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </SquareButton>
        <ExpandButton
          onClick={() => setShowResetPassword(!showResetPassword)}
          sx={{ width: "90vw" }} // 🔹 Reduce width here
        >
          Reset Password
        </ExpandButton>
      </Box>

      {/* Smooth Transition for Password Fields */}
      <Collapse in={showResetPassword} timeout={300}>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            width: "30vw", // 🔹 Increased width slightly
            // maxWidth: "550px", // 🔹 Max width for large screens
            mt: 3,
            padding: "35px", // 🔹 More padding inside the box
            borderRadius: "15px", // 🔹 Smooth rounded edges
            boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)", // 🔹 Stronger shadow effect
            backgroundColor: "#fff", // 🔹 White background for contrast
            transition: "0.3s ease",
          }}
        >
          <h2
            style={{
              display: "flex",
              justifyContent: "center", // ✅ Ensures proper centering
              alignItems: "center",
              textAlign: "center", // ✅ Centers text inside the element
              fontSize: "2rem",
              fontWeight: "bold",
              color: "#222",
              letterSpacing: "1px",
              marginBottom: "20px",
              width: "100%", // ✅ Ensures it takes full width
            }}
          >
            Reset Password
          </h2>

          <TextField
            label="New Password *"
            type="password"
            name="newPassword"
            value={input.newPassword}
            onChange={handleChange}
            required
            fullWidth
            variant="outlined"
            sx={{
              fontSize: "1.1rem",
              padding: "12px",
              borderRadius: "8px", // 🔹 Rounded inputs
              backgroundColor: "#f7f7f7", // 🔹 Soft background
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#ddd" }, // 🔹 Light border
                "&:hover fieldset": { borderColor: "#007bff" }, // 🔹 Hover effect
                "&.Mui-focused fieldset": {
                  borderColor: "#007bff",
                  borderWidth: "2px",
                }, // 🔹 Focus effect
              },
            }}
          />

          <TextField
            label="Confirm New Password *"
            type="password"
            name="confirmPassword"
            value={input.confirmPassword}
            onChange={handleChange}
            required
            fullWidth
            variant="outlined"
            sx={{
              fontSize: "1.1rem",
              padding: "12px",
              borderRadius: "8px",
              backgroundColor: "#f7f7f7",
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#ddd" },
                "&:hover fieldset": { borderColor: "#007bff" },
                "&.Mui-focused fieldset": {
                  borderColor: "#007bff",
                  borderWidth: "2px",
                },
              },
            }}
          />

          {error && (
            <Box
              sx={{
                color: "red",
                fontSize: "0.9rem",
                textAlign: "center",
                fontWeight: "bold",
                marginTop: "10px",
              }}
            >
              {error}
            </Box>
          )}

          <Button type="submit" variant="contained" sx={buttonStyle}>
            🔐 Reset Password
          </Button>
        </Box>
      </Collapse>
      {/* Confirmation Dialog */}
      <Dialog
        open={dialogOpen}
        onClose={() => handleDialogClose(false)}
        sx={{
          "& .MuiDialog-paper": {
            padding: "20px",
            borderRadius: "12px",
            minWidth: "350px",
            boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        {/* ✅ Centered & Bold Title */}
        <DialogTitle
          sx={{
            fontWeight: "bold",
            fontSize: "1.4rem",
            textAlign: "center",
            color: "#333",
          }}
        >
          {tempOptIn ? "Confirm Opt-in SMS" : "Confirm Opt-out SMS"}
        </DialogTitle>

        {/* ✅ Centered Content */}
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <DialogContentText
            sx={{
              textAlign: "center",
              fontSize: "1rem",
              color: "#555",
              marginBottom: "15px",
              width: "100%",
            }}
          >
            {tempOptIn
              ? "You are opting in to receive SMS notifications. Do you want to proceed?"
              : "You are opting out of SMS notifications. You will no longer receive SMS updates. Are you sure you want to continue?"}
          </DialogContentText>
        </DialogContent>

        {/* ✅ Centered Buttons */}
        <DialogActions
          sx={{
            justifyContent: "center",
            gap: "15px",
            paddingBottom: "15px",
          }}
        >
          <Button
            onClick={() => handleDialogClose(false)}
            sx={{
              ...buttonStyle,
              backgroundColor: "red",
              color: "white",
              "&:hover": {
                backgroundColor: "darkred",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleDialogClose(true)}
            sx={{
              ...buttonStyle,
              fontWeight: "bold",
            }}
          >
            {tempOptIn ? "Opt-in" : "Opt-out"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PasswordChange;
